[
  {
    "code": "NP-3",
    "name": "Bagmati"
  },
  {
    "code": "NP-4",
    "name": "Gandaki"
  },
  {
    "code": "NP-6",
    "name": "Karnali"
  },
  {
    "code": "NP-5",
    "name": "Lumbini"
  },
  {
    "code": "NP-2",
    "name": "Madhesh"
  },
  {
    "code": "NP-1",
    "name": "Province 1"
  },
  {
    "code": "NP-7",
    "name": "Sudurpaschim"
  }
]